import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Form.css'; // Ensure this file includes your provided styles
import { Country, State, City } from "country-state-city";
import Select from "react-select";
import 'font-awesome/css/font-awesome.css'; // Import Font Awesome

const UserData = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    address: '',
    city: '',
    state: '',
    zipCode: '',
    yearBuilt: '',
    phone: '',
    cell: '',
    work: ''
  });

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const defaultCountry = Country.getAllCountries().find(country => country.name === 'United States');
  const [selectedCountry, setSelectedCountry] = useState(defaultCountry);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);

  // Load stored data on mount
  useEffect(() => {
    const storedData = JSON.parse(sessionStorage.getItem('formData'));
    if (storedData) {
      setFormData(storedData);
    }

    const storedState = JSON.parse(sessionStorage.getItem('selectedState'));
    const storedCity = JSON.parse(sessionStorage.getItem('selectedCity'));

    if (storedState) {
      setSelectedState(storedState);
      setFormData(prevData => ({ ...prevData, state: storedState.name }));
    }

    if (storedCity) {
      setSelectedCity(storedCity);
      setFormData(prevData => ({ ...prevData, city: storedCity.name }));
    }

    // Clear storage on page refresh
    const handleBeforeUnload = () => {
      sessionStorage.clear(); // Clear all sessionStorage data
      localStorage.clear(); // Clear all localStorage data
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);
  const UserTablepage =()=>[
    navigate('/components/UserTable')
]


  const validate = () => {
    const newErrors = {};
    if (!formData.firstName.trim()) newErrors.firstName = "First Name is required";
    if (!formData.lastName.trim()) newErrors.lastName = "Last Name is required";
    if (!formData.address.trim()) newErrors.address = "Address is required";
    if (!formData.state.trim()) newErrors.state = "State is required";
    if (!/^\d{10}$/.test(formData.phone)) newErrors.phone = "Phone number must be 10 digits";
    if (formData.yearBuilt && !/^\d{4}$/.test(formData.yearBuilt)) newErrors.yearBuilt = "Year Built must be a 4-digit number";
    return newErrors;
  };

  const updateSessionStorage = (data) => {
    sessionStorage.setItem('formData', JSON.stringify(data));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length === 0) {
      updateSessionStorage(formData);
      sessionStorage.setItem('selectedState', JSON.stringify(selectedState));
      sessionStorage.setItem('selectedCity', JSON.stringify(selectedCity));
      navigate(`/components/doorConfig/${undefined}`, { state: { formData } });

      setFormData({
        firstName: '',
        lastName: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
        yearBuilt: '',
        phone: '',
        cell: '',
        work: ''
      });
      setSelectedState(null); // Reset state selection
      setSelectedCity(null); // Reset city selection
      setErrors({});
    } else {
      setErrors(validationErrors);
    }
  };

  const handleRefresh = () => {
    sessionStorage.clear(); // Clear all sessionStorage data
    localStorage.clear(); // Clear all localStorage data
    setFormData({
      firstName: '',
      lastName: '',
      address: '',
      city: '',
      state: '',
      zipCode: '',
      yearBuilt: '',
      phone: '',
      cell: '',
      work: ''
    });
    setSelectedState(null); // Reset state selection
    setSelectedCity(null); // Reset city selection
    setErrors({});
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedData = { ...formData, [name]: value };
    setFormData(updatedData);
    updateSessionStorage(updatedData);
  };

  const handleStateChange = (item) => {
    setSelectedState(item);
    const updatedData = { ...formData, state: item.name };
    setFormData(updatedData);
    updateSessionStorage(updatedData);
    sessionStorage.setItem('selectedState', JSON.stringify(item)); // Store selected state
    setSelectedCity(null); // Reset city when state changes
  };

  const handleCityChange = (item) => {
    setSelectedCity(item);
    const updatedData = { ...formData, city: item.name };
    setFormData(updatedData);
    updateSessionStorage(updatedData);
    sessionStorage.setItem('selectedCity', JSON.stringify(item)); // Store selected city
  };

  return (
    <div className="form-container" style={{height:'100vh'}}>
      <form className="responsive-form" onSubmit={handleSubmit}>
        <h2 className="form-heading">Customer Information</h2>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="firstName" className="LabelTop">First Name</label>
            <div className="input-icon">
              <i className="fa fa-user" aria-hidden="true"></i>
              <input
                type="text"
                id="firstName"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
            </div>
            {errors.firstName && <p className="error">{errors.firstName}</p>}
          </div>
          <div className="form-group">
            <label htmlFor="lastName" className="LabelTop">Last Name</label>
            <div className="input-icon">
              <i className="fa fa-user" aria-hidden="true"></i>
              <input
                type="text"
                id="lastName"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </div>
            {errors.lastName && <p className="error">{errors.lastName}</p>}
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="address" className="LabelTop">Address</label>
            <div className="input-icon">
              <i className="fa fa-home" aria-hidden="true"></i>
              <input
                type="text"
                id="address"
                name="address"
                value={formData.address}
                onChange={handleChange}
                required
              />
            </div>
            {errors.address && <p className="error">{errors.address}</p>}
          </div>
          <div className="form-group">
            <label htmlFor="zipCode" className="LabelTop">ZIP Code</label>
            <div className="input-icon">
              <i className="fa fa-map-pin" aria-hidden="true"></i>
              <input
                type="text"
                id="zipCode"
                name="zipCode"
                value={formData.zipCode}
                onChange={handleChange}
                required
              />
            </div>
            {errors.zipCode && <p className="error">{errors.zipCode}</p>}
          </div>
        </div>

        <div className="dropdown-container form-row">
          <div className="dropdown-item">
            <label htmlFor="state-select">Select State</label>
            <Select
              required
              id="state-select"
              className="state-dropdown"
              options={State.getStatesOfCountry(selectedCountry.isoCode)}
              getOptionLabel={(options) => options.name}
              getOptionValue={(options) => options.isoCode}
              value={selectedState}
              onChange={handleStateChange}
            />
            {errors.state && <p className="error">{errors.state}</p>}
          </div>
          <div className="dropdown-item">
            <label htmlFor="city-select">Select City</label>
            <Select
              required
              id="city-select"
              className="city-dropdown"
              options={City.getCitiesOfState(selectedCountry.isoCode, selectedState?.isoCode)}
              getOptionLabel={(options) => options.name}
              getOptionValue={(options) => options.id}
              value={selectedCity}
              onChange={handleCityChange}
            />
          </div>
        </div>
        <br />

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="yearBuilt" className="LabelTop">Year Built</label>
            <input
              type="text"
              id="yearBuilt"
              name="yearBuilt"
              value={formData.yearBuilt}
              onChange={handleChange}
              maxLength="4"
              placeholder="YYYY"
            />
            {errors.yearBuilt && <p className="error">{errors.yearBuilt}</p>}
          </div>
          <div className="form-group">
            <label htmlFor="phone" className="LabelTop">Phone</label>
            <div className="input-icon">
              <i className="fa fa-phone" aria-hidden="true"></i>
              <input
                type="text"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>
            {errors.phone && <p className="error">{errors.phone}</p>}
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="cell" className="LabelTop">Cell</label>
            <div className="input-icon">
              <i className="fa fa-mobile" aria-hidden="true"></i>
              <input
                type="text"
                id="cell"
                name="cell"
                value={formData.cell}
                onChange={handleChange}
              />
            </div>
            {errors.cell && <p className="error">{errors.cell}</p>}
          </div>
          <div className="form-group">
            <label htmlFor="work" className="LabelTop">Work</label>
            <div className="input-icon">
              <i className="fa fa-briefcase" aria-hidden="true"></i>
              <input
                type="text"
                id="work"
                name="work"
                value={formData.work}
                onChange={handleChange}
              />
            </div>
            {errors.work && <p className="error">{errors.work}</p>}
          </div>
        </div>

        <div className='divcenter form-row'> 
          <button type="button" className="refresh-button btn-design" onClick={handleRefresh}>Refresh</button>
          <button type="submit" className="submit-button btn-design">Submit</button>
         </div>

        <div className='divcenter form-row'>  
        <button className="AdminButton btn-primary" style={{marginLeft:'10px',}} onClick={UserTablepage}>Open admin</button>
        </div>

        
      </form>
    </div>
  );
};

export default UserData;
